import React from "react";
import styles from "../styles/communityPage.module.css";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingCircle from "../../globalModule/components/loadingCircle";
import CommunityItem from "./communityItem";
const CommunityPage = ({
  communitiesState,
  setCommunitiesState,
  updateData,
  hasMore,
  toggleModal,
  setCommunityID
}) => {
  return <div data-sentry-component="CommunityPage" data-sentry-source-file="communityPage.jsx">
      <InfiniteScroll dataLength={communitiesState?.length || 0} next={updateData} hasMore={hasMore} loader={communitiesState?.length < 10 ? "" : <LoadingCircle />} data-sentry-element="InfiniteScroll" data-sentry-source-file="communityPage.jsx">
        <div className={styles.communitiesContainer}>
          {communitiesState && communitiesState.map((item, index) => <CommunityItem key={index} currentValue={item} index={index} toggleModal={toggleModal} setCommunityID={setCommunityID} communitiesState={communitiesState} setCommunitiesState={setCommunitiesState} />)}
        </div>
      </InfiniteScroll>
    </div>;
};
export default CommunityPage;